import { Injectable }    from '@angular/core';
import { HttpClient, HttpHeaders  } from '@angular/common/http';
import { Observable } from 'rxjs';

import * as ent from '../entities/index'
import * as filters from '../filters/index'
import * as serv from '../services/index'


@Injectable()
export class CustomerService {

    private baseCustomerUrl = "/Customer";  // URL to web api
    private getCustomersURL = '';
    private getFullServiceCustomersURL = '';
    private getCustomerDetailsURL = '';
    private getPayersURL = '';

  
    appConfig: ent.AppConfig;

    constructor(private httpClient: HttpClient, private configService: serv.ConfigService) {
        this.baseCustomerUrl = this.configService.appConfig.UrlBase + this.baseCustomerUrl;

        this.getCustomersURL = this.baseCustomerUrl + '/GetCustomers';
        this.getFullServiceCustomersURL = this.baseCustomerUrl + '/GetFullServiceCustomers';
        this.getCustomerDetailsURL = this.configService.appConfig.UrlBase + '/CONA/CustomerDetails';
        this.getPayersURL = this.baseCustomerUrl + '/GetPayers';
    }

    getCustomers(filter: filters.CustomerFilter): Observable<ent.Customer[]> {
        return this.httpClient.post<ent.Customer[]>(this.getCustomersURL, filter);
    }

    getFullServiceCustomers(filter: filters.CustomerFilter): Observable<ent.FullServiceCustomer[]> {
        return this.httpClient.post<ent.FullServiceCustomer[]>(this.getFullServiceCustomersURL, filter);
    }

    getCustomerDetails(request: ent.CustomerDetailsRequest): Observable<ent.CustomerDetailsResponse> {
        return this.httpClient.post<ent.CustomerDetailsResponse>(this.getCustomerDetailsURL, request);
    }

    getPayers(request: ent.GetPayersRequest): Observable<ent.Customer[]> {
        return this.httpClient.post<ent.Customer[]>(this.getPayersURL, request);
    }

}
